import { render, staticRenderFns } from "./GeneralComments.vue?vue&type=template&id=6d4e4302&scoped=true"
import script from "./GeneralComments.vue?vue&type=script&lang=js"
export * from "./GeneralComments.vue?vue&type=script&lang=js"
import style0 from "./GeneralComments.vue?vue&type=style&index=0&id=6d4e4302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e4302",
  null
  
)

export default component.exports